/*
 * jQuery One Page Nav Plugin
 * http://github.com/davist11/jQuery-One-Page-Nav
 * http://trevordavis.net/blog/jquery-one-page-navigation-plugin
 *
 * Copyright (c) 2010 Trevor Davis (http://trevordavis.net)
 * Dual licensed under the MIT and GPL licenses.
 * Uses the same license as jQuery, see:
 * http://jquery.org/license
 *
 * @version 3.0.0
 *
 * Example usage:
 * $('#nav').onePageNav({
 *   currentClass: 'current',
 *   changeHash: false,
 *   scrollSpeed: 750
 * });
 */

;(function($, window, document, undefined){

  // our plugin constructor
  var OnePageNav = function(elem, options){
    this.elem = elem;
    this.$elem = $(elem);
    this.options = options;
    this.metadata = this.$elem.data('plugin-options');
    this.$win = $(window);
    this.sections = {};
    this.didScroll = false;
    this.$doc = $(document);
    this.docHeight = this.$doc.height();
  };

  // the plugin prototype
  OnePageNav.prototype = {
    defaults: {
      navItems: 'a',
      currentClass: 'current',
      currentParentClass: 'subcurrent',
      tabItem: 'li',
      changeHash: false,
      easing: 'swing',
      filter: '',
      scrollSpeed: 750,
      begin: false,
      end: false,
      scrollChange: false,
      scrollChangeTolerance: 20,
      // scrollChangeTolerance is used so that scrollChange function does not impact selected menu onclick of a tab
      fixedTopBar: $("body").hasClass("top_bar_fixed"),
      fixedMenu: $("body").hasClass("menu_fixed"),
      themeVertical: $("body").hasClass("theme_vertical")
    },

    init: function() {
      var self = this;

      // Introduce defaults that can be extended either
      // globally or using an object literal.
      this.config = $.extend({}, this.defaults, this.options, this.metadata);

      this.$nav = this.$elem.find(this.config.navItems);

      //Filter any links out of the nav
      if(this.config.filter !== '') {
        this.$nav = this.$nav.filter(this.config.filter);
      }

      //Handle clicks on the nav
      this.$nav.on('click.onePageNav', $.proxy(this.handleClick, this));

      //Get the section positions
      this.getPositions();

      //Handle scroll changes
      this.bindInterval();

      //Update the positions on resize too
      this.$win.on('resize.onePageNav', $.proxy(this.getPositions, this));

      $(window).on('hashchange', function(e){
        var hash = window.location.hash,
            $target = $(hash);

        if($target.length) {
          var offset = $target.offset().top - self.getNavOffset();
          window.scrollTo(0, offset);
        }
      });

      return this;
    },

    adjustNav: function(self, $parent) {
      self.$elem.find('.' + self.config.currentClass).removeClass(self.config.currentClass);
      self.$elem.find('.' + self.config.currentParentClass).removeClass(self.config.currentParentClass);
      $parent.addClass(self.config.currentClass);
      $parent.parents(self.config.tabItem).addClass(self.config.currentParentClass);
    },

    bindInterval: function() {
      var self = this;
      var docHeight;

      self.$win.on('scroll.onePageNav', function() {
        self.didScroll = true;
      });

      self.t = setInterval(function() {
        docHeight = self.$doc.height();

        //If it was scrolled
        if(self.didScroll) {
          self.didScroll = false;
          self.scrollChange();
        }

        //If the document height changes
        if(docHeight !== self.docHeight) {
          self.docHeight = docHeight;
          self.getPositions();
        }
      }, 250);
    },

    getHash: function($link) {
      return $link.attr('href').split('#')[1];
    },

    getPositions: function() {
      var self = this;
      var linkHref;
      var topPos;
      var $target;

      self.$nav.each(function() {
        linkHref = self.getHash($(this));
        $target = $('#' + linkHref);

        if($target.length) {
          topPos = $target.offset().top;
          self.sections[linkHref] = Math.round(topPos);
        }
      });
    },

    getNavOffset: function() {
      var offset  = 0,
          $menu   = $("body").find("#menu"),
          $topbar = $("body").find("#top-bar-inner");

      if($menu.length && this.config.fixedMenu) {
        offset += $menu.height();
      }

      if ($topbar.length && this.config.fixedTopBar) {
        offset += $topbar.height();
      }

      return offset;
    },

    getSection: function(windowPos) {
      var returnValue = null;
      var self = this;

      for(var section in this.sections) {
        if((this.sections[section] - self.getNavOffset() - this.config.scrollChangeTolerance) < windowPos) {
          returnValue = section;
        }
      }

      return returnValue;
    },

    handleClick: function(e) {
      var self = this;
      var $link = $(e.currentTarget);
      var $parent = $link.closest(self.config.tabItem);
      var newLoc = '#' + self.getHash($link);

      var $target = $(newLoc);

      var currentScrollTop = $(window).scrollTop();
      var targetTop = $target.offset().top - self.getNavOffset();
      var alreadyAtPosition = Math.abs(currentScrollTop - targetTop) < 5;

      if (!alreadyAtPosition) {
        //Start callback
        if(self.config.begin) {
          self.config.begin();
        }

        //Change the highlighted nav item
        self.adjustNav(self, $parent);

        //Removing the auto-adjust on scroll
        self.unbindInterval();

        //Scroll to the correct position
        self.scrollTo(newLoc, function() {
          //Do we need to change the hash?
          if(self.config.changeHash) {
            window.location.hash = newLoc;
          }

          //Add the auto-adjust on scroll back in
          self.bindInterval();

          //End callback
          if(self.config.end) {
            self.config.end();
          }
        });
      }

      e.preventDefault();
    },

    scrollChange: function() {
      var windowTop = this.$win.scrollTop();
      var position = this.getSection(windowTop);
      var $parent;

      //If the position is set
      if(position !== null) {
        $parent = this.$elem.find('a[href$="#' + position + '"]').closest(this.config.tabItem);

        //If it's not already the current section
        if(!$parent.hasClass(this.config.currentClass)) {
          //Change the highlighted nav item
          this.adjustNav(this, $parent);

          //If there is a scrollChange callback
          if(this.config.scrollChange) {
            this.config.scrollChange($parent);
          }
        }
      }
    },

    scrollTo: function(target, callback) {
      var self = this;
          offset = $(target).offset().top,
          bodyContainerId = '#body-container-inner',
          $bodyContainer = $(bodyContainerId);

      if(!self.config.themeVertical) {
        offset -= self.getNavOffset();
      }

      if(offset > 0 && $bodyContainer.css('position') == 'absolute') {
        offset += $bodyContainer.scrollTop();
      }

      $('html, body, ' + bodyContainerId).animate({
        scrollTop: offset
      });
    },

    unbindInterval: function() {
      clearInterval(this.t);
      this.$win.unbind('scroll.onePageNav');
    }
  };

  OnePageNav.defaults = OnePageNav.prototype.defaults;

  $.fn.onePageNav = function(options) {
    return this.each(function() {
      new OnePageNav(this, options).init();
    });
  };

})( jQuery, window , document );
